module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "far fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.notificationSize))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.notificationSize) + " notification(s)")]), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('li', {
      key: notification._id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Testimony',
          params: {
            id: notification._id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope text-wwow"
    }), _vm._v(" A new testimony has been reported\n                      ")])], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('p', {
    staticClass: "navbar-text"
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.demo.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), (_vm.user) ? _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Login',
        query: {
          logout: 'yes'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out-alt"
  }), _vm._v(" Logout\n              ")])], 1)])])])]), _vm._v(" "), (_vm.user) ? _c('sidebar', {
    attrs: {
      "role": _vm.user.role,
      "display-name": _vm.user.displayName,
      "picture-url": _vm.demo.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "page-nav"
  }, [(_vm.$route.name === 'Testimony' || _vm.$route.name === 'TestimonyHistory') ? _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-nav-item",
    class: {
      'active': _vm.$route.name === 'Testimony'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Testimony', _vm.$route.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-android-list"
  }), _vm._v(" Detail\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-nav-item",
    class: {
      'active': _vm.$route.name === 'TestimonyHistory'
    },
    on: {
      "click": function($event) {
        return _vm.goTo('TestimonyHistory', _vm.$route.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-android-time"
  }), _vm._v(" History \n              ")])])]) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" HOME\n            ")])], 1), _vm._v(" "), (_vm.$route.meta.parentName) ? _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.meta.parentName
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$route.meta.parentName.toUpperCase()) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'Dashboard') ? _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$route.name.toUpperCase()) + "\n            ")])], 1) : _vm._e()])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "img-responsive center-block logo"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4922cefe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 436
// module chunks = 1